import React from "react";
import { Container, Image, Navbar } from "react-bootstrap";
// /import ThemeNavDropdown from "../dropdowns/ThemeNavDropdown";

const OnlyLogoNavbar = (props) => {
    return (
        <Navbar expand="lg" sticky="top" id={props.id}>
            <Container>
                <Navbar.Brand href="/">
                    <Image src="/images/pt_logo.svg" alt="pole therapy logo" className="logo-navbar" />
                </Navbar.Brand>
                {/* <ThemeNavDropdown /> */}
            </Container>
        </Navbar>
    );
};

export default OnlyLogoNavbar;
